var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5B8C\\u4E86",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_13",
    "data-name": "\\u6955\\u5186\\u5F62 13",
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#efefff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1617",
    "data-name": "\\u30D1\\u30B9 1617",
    d: "M-3363.35-2231.5a4.55,4.55,0,0,1-2.9-.988,3.4,3.4,0,0,1-1.329-2.636v-57.1a6.646,6.646,0,0,1-1.438-8.606,6.645,6.645,0,0,1,8.324-2.612,6.645,6.645,0,0,1,3.736,7.884c7.167-2.612,14.266-.356,21.153,1.855,7.528,2.414,14.637,4.694,21.747.948a2.206,2.206,0,0,1,2.2.064,2.187,2.187,0,0,1,1.064,1.887v35.946a2.231,2.231,0,0,1-1.068,1.9,19.483,19.483,0,0,1-10.339,2.857c-4.844,0-9.635-1.536-14.334-3.042-7.81-2.5-15.194-4.854-22.585-.457v18.473a3.966,3.966,0,0,1-3.949,3.635C-3363.163-2231.491-3363.257-2231.494-3363.35-2231.5Zm-1.812-3.625a1.041,1.041,0,0,0,.428.761,2.2,2.2,0,0,0,1.384.447c1.068,0,1.812-.637,1.812-1.208v-55.833a6.507,6.507,0,0,1-3.625,0Zm29.365-20.317c7.814,2.5,15.2,4.874,22.586.476v-35.5c-7.912,4.01-15.746,1.5-23.325-.933-7.81-2.511-15.194-4.855-22.585-.458v35.494a19.49,19.49,0,0,1,9.007-2.114C-3345.278-2258.479-3340.491-2256.949-3335.8-2255.442Zm-31.782-41.9a4.229,4.229,0,0,0,4.229,4.229,4.229,4.229,0,0,0,4.229-4.229,4.229,4.229,0,0,0-4.229-4.229A4.229,4.229,0,0,0-3367.579-2297.346Zm24.514,32.874-4.833-4.833a1.208,1.208,0,0,1,.015-1.694,1.207,1.207,0,0,1,1.693-.015l4.043,4.041,16.069-13.773,0,0a1.208,1.208,0,0,1,1.668.16,1.209,1.209,0,0,1-.1,1.673l-16.915,14.5a1.205,1.205,0,0,1-.786.29A1.206,1.206,0,0,1-3343.065-2264.472Z",
    transform: "translate(3406.466 2334.472)",
    fill: "#2f2d83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.36aa3418bea8f3c3b3a31e951d20ba3d.svg";
export { ForwardRef as ReactComponent };